import { createContext, ReactNode, useMemo, useState } from 'react';

import { defaultSnackProps, SnackProps } from 'components/Snack';

export type SnackContextProps = {
  snack: SnackProps;
  setSnack: React.Dispatch<React.SetStateAction<SnackProps>>;
};

export const defaultSnackContextProps: SnackContextProps = {
  snack: defaultSnackProps,
  setSnack: () => void 0,
};

export const SnackContext = createContext<SnackContextProps>(
  defaultSnackContextProps,
);

export const SnackProvider = (props: { children: ReactNode }) => {
  const [snack, setSnack] = useState<SnackProps>(defaultSnackProps);

  const memoizedReturn = useMemo(
    () => ({
      snack,
      setSnack,
    }),
    [snack, setSnack],
  );

  return (
    <SnackContext.Provider value={memoizedReturn}>
      {props.children}
    </SnackContext.Provider>
  );
};
